module.exports = __webpack_public_path__ + "img/map-message-3.be84c61b.png";